import Page from '../base/Page';
import '../libs/popup';

export default class BlogPage extends Page
{
    constructor() {
        super('.blog-template');
    }

    init() {
        this.BlogPopup();
    }

    BlogPopup() {
        this.addEvent('.lightbox', 'click', e => this.show(e));
    }

    show(e) {
        let img = $(e.currentTarget).find('img').clone();
        e.preventDefault();
        img.popup({
            popupHTML: '<div class="popup blog-img"><div class="popup-content"></div></div>',
            overlayHTML: '<div class="popup-overlay image-modal-overlay"><div class="close-popup icon-close" title="Close"></div></div>',
            fadeIn: false
        });
    }
}


// WEBPACK FOOTER //
// ./javascript/pages/Blog.js